import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

import { Flex, TextField } from '@decisiv/ui-components';
import Checkmark from '@decisiv/iconix/lib/components/CheckCircleF';
import TimesCircle from '@decisiv/iconix/lib/components/TimesCircle';

import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';

export const CssResetStyle = createGlobalStyle`
  [class*="Message__Container"] p {
    font-size: 12px;
    margin: 0;
  }
`;

export const ButtonsContainer = styled(Flex)`
  flex-direction: column;
  width: 100%;
  row-gap: 5px;
  align-items: start;

  @media screen and (max-width: 390px) {
    flex-direction: column-reverse;

    .btn__element--login-btn {
      margin-bottom: 15px;
    }
  }
`;

export const StyledAlert = styled.div`
  margin-bottom: 20px;

  p {
    margin-top: 0;
    margin-bottom: 0;
    font-weight: 600;
  }
`;

export const InnerContainer = styled(Flex).attrs({
  flexDirection: 'column',
  alignItems: 'center',
})`
  width: 560px;
  background-color: ${toColorString(color.base.snowWhite)};
  padding: 50px 40px;
`;

export const MainContainer = styled(Flex).attrs({ flexDirection: 'column' })`
  background-color: ${toColorString(color.base.halfMoon)};
  margin: -15px -15px 60px -20px;
  min-height: calc(100vh - 130px);
  padding: 50px 0 20px;
`;

export const StyledTextField = (props) => {
  return (
    <Flex marginBottom={1}>
      <TextField {...props} />
    </Flex>
  );
};

const iconStyle = {
  margin: '2px 5px 0 0',
  flexShrink: '0',
};

export const IconPass = () => {
  return <Checkmark size="small" color="#47B052" style={iconStyle} />;
};

export const IconFail = () => {
  return <TimesCircle size="small" color="#C5CAD3" style={iconStyle} />;
};

export const RequirementDiv = styled.div`
  font-size: 12px;
  display: flex;
  color: #737482;
  line-height: 140%;
  margin-bottom: 2px;
`;
